// This file is AUTOGENERATED, do not edit it manually!!!

export const inlineEdit = {
    action_has_been_successfully_undone: '{0} успешно отменено',
    action_has_not_been_successfully_undone: 'К сожалению, мы не смогли отменить действие.',
    ActivityChildrenActualHours_Text: 'Тайм-логи для вложенных активностей:',
    ActivityChildrenEstimatedHours_Text: 'Ожидаемые часы для вложенных активностей:',
    ActivityOwnBudget_Text: 'Бюджет задачи:',
    ActivityOwnEstimatedHours_Text: 'Ожидаемые часы для активности:',
    ActivitySubactivitiesBudget_Text: 'Бюджет для всех подзадач:',
    ActualCompletion_Text: 'Фактическое окончание',
    ActualHours_Total_Text: 'Фактические часы, итого:',
    AddTimeEntry_Text: 'Добавить тайм-лог',
    AddUser_Text: 'Пригласить пользователя',
    AddWeeklyTime_Text: 'Добавить время за неделю',
    Apply: 'Применить',
    Assignees_Text: 'Назначенные',
    BudgetedCost_Text: 'Общий бюджет:',
    BudgetPadding_Text: 'Запас бюджета:',
    BudgetTotal_Text: 'Бюджет, итого:',
    Cancel: 'Отмена',
    Close: 'Закрыть',
    Combobox_Add: 'Добавить ',
    Combobox_KeepTyping: 'Введите текст....',
    Combobox_NoResults: 'Ничего не найдено',
    Combobox_NoResultsMatch: 'Ничего не найдено по ',
    confirmation_description_dependent_date: 'Вы собираетесь изменить дату активности, которая имеет зависимости. Это действие скорректирует лаги зависимостей в соответствии с новой датой, которую вы указали.',
    confirmation_title_dependent_date: 'Эта дата связана с зависимой активностью',
    Cost_Text: 'Стоимость:',
    CreateAndSelect: 'Создать и выбрать',
    CustomerLabel: 'Заказчик',
    day_template: '1#{0} дня#{0} дней',
    Duration_Text: 'Длительность',
    EditProjectMembers_Title: 'Члены проекта',
    EditTaskAssignees_Title: 'Назначенные',
    End_Text: 'Окончание',
    EndDate_Text: 'Дата окончания',
    EstimatedHours_Text: 'Ожидаемые часы:',
    EstimatedHours_Total_Text: 'Ожидаемые часы, итого:',
    field_for_all_activities: 'Это поле предназначено только для активностей <b style=\"white-space: nowrap;\">({0} задач, {1} проблем, {2} запросов)</b>',
    field_for_issues: 'Это поле предназначено только для <b style=\"white-space: nowrap;\">{0} проблем</b>',
    field_for_projects: 'Это поле предназначено только для <b style=\"white-space: nowrap;\">{0} проектов</b>',
    field_for_requests: 'Это поле предназначено только для <b style=\"white-space: nowrap;\">{0} запросов</b>',
    field_for_tasks: 'Это поле предназначено только для <b style=\"white-space: nowrap;\">{0} задач</b>',
    Hours_Short_Text: 'ч',
    HoursLeftLabel: 'Осталось часов:',
    InternalCost_Text: 'Факт. стоимость:',
    NonProjectMembers_Text: 'Пользователи',
    Not_Space_Members: 'Не члены рабочего пространства',
    Overloaded_Text: 'Перегруженные',
    OwnActualHours_Text: 'Тайм-логи для активности:',
    PlannedExpenses_Text: 'Запланированные расходы:',
    PortfolioLabel: 'Портфолио',
    Progress: 'Прогресс',
    ProgressCalculatedBySubActivities: 'Вычисляется на основании дочерних активностей',
    ProjectChildrenActualHours_Text: 'Тайм-логи:',
    ProjectChildrenEstimatedHours_Text: 'Ожидаемые часы для активностей:',
    ProjectMembers_Text: 'Члены проекта',
    ProjectOwnBudget_Text: 'Бюджет труда проекта:',
    ProjectOwnEstimatedHours_Text: 'Ожидаемые часы для проекта:',
    ProjectSubactivitiesBudget_Text: 'Бюджет всех задач:',
    Space_Members: 'Члены рабочего пространства',
    Start_Text: 'Начало',
    StartDate_Text: 'Дата начала',
    Teams_Text: 'Команды',
    Timelogs_In_Past: 'Редактирование времени для активности, которая произошла более {0} назад, не рекомендуется. Вы уверены, что хотите продолжить?',
    Timelogs_In_Past_Short: 'Редактирование времени для активности, которая произошла более {0} назад, не рекомендуется',
    TimeLogs_Warning_Project_Closed: 'Добавлeние тайм-лога в закрытый проект не рекомендуется. Вы уверены, что хотите продолжить добавление тайм-лога в закрытый проект?',
    TimeLogs_Warning_Project_Closed_Short: 'Добавлeние тайм-лога в закрытый проект не рекомендуется',
    TimeLogs_Warning_Task_Closed: 'Добавление тайм-лога в закрытую активность не рекомендуется. Вы уверены, что хотите продолжить добавление тайм-лога в эту закрытую активность?',
    TimeLogs_Warning_Task_Closed_Short: 'Добавление тайм-лога в закрытую активность не рекомендуется',
    Tooltip_Dependent_Template: '{0} связана с зависимой активностью и не может быть изменена',
    Tooltip_HasChildren_Template: '{0} вычисляется на основании дочерних активностей и не может быть изменена',
    Tooltip_ItemCompleted: 'Редактирование невозможно, т.к. относится к закрытой активности/проекту.',
    Tooltip_NoRightForUserRole_Template: '{0} не может быть изменена. У вас нет разрешения редактировать это поле',
    Tooltip_Open_Details: 'Пожалуйста, откройте детали для редактирования',
    undo_action_Project_UpdateActualCompletionDate: 'изменение фактической даты окончания проекта',
    undo_action_Project_UpdateDates: 'изменение дат проекта',
    undo_action_Project_UpdateName: 'переименование проекта',
    undo_action_Project_UpdateStatus: 'изменение статуса проекта',
    undo_action_Task_UpdateActualCompletionDate: 'изменение фактической даты окончания активности',
    undo_action_Task_UpdateDates: 'изменение дат активности',
    undo_action_Task_UpdateDependencies: 'редактирование зависимости',
    undo_action_Task_UpdateName: 'переименование активности',
    undo_action_Task_UpdateStatus: 'изменение статуса активности',
    undo_action_Task_UpdateWorkIsDone: 'изменения \'Работу выполнил\' для назначеной задачи',
    Untitled: 'Без имени',
    Validation_ActComplDateRange: 'Факт. дата завершения не входит в указанный диапазон.',
    Validation_DateMandatory: 'Дата обязательна для заполнения.',
    Validation_DurationMandatory: 'Длительность обязательна для заполнения.',
    Validation_EndDateRange: 'Дата окончания не входит в указанный диапазон.',
    Validation_FieldMandatory: 'Поле обязательно для заполнения.',
    Validation_FromDateRange: 'Дата с не входит в указанный диапазон.',
    Validation_Interger: 'Значение должно быть целым числом',
    Validation_InvalidDate: 'Введите дату в формате \'{0}\'.',
    Validation_NumberRange: 'Значение должно попадать в интервал с {0} до {1}.',
    Validation_Range: 'Значение не попадает в интервал допустимых.',
    Validation_StartDateRange: 'Дата начала не входит в указанный диапазон.',
    Validation_ToDateRange: 'Дата по не входит в указанный диапазон.',
    Validation_WeekendOrVacation: 'Значение не должна попадать на выходные или праздничные дни.',
    Warning_UnassigneFromAllTasksInProject: 'Удаленные члены проекта будут сняты со всех задач.',
    Warning_UnassignFromAllTasksInProject_Single: 'Удаленный член проекта будет снят со всех задач.',
};
